import { useLocation, useOutletContext, useParams } from "react-router";
import { Link, Outlet } from "react-router-dom";
import { CaseLayoutContext } from "../case/case";
import { useEffect, useState } from "react";
import clsx from "clsx";

export default function ClaimantDetailsViewLayout() {
    const params = useParams();
    const outletContext = useOutletContext<CaseLayoutContext>();
    const location = useLocation();
    const [currentTab, setCurrentTab] = useState<string>('index');
    const [isFundView, setIsFundView] = useState<boolean>(false);

    useEffect(() => {
        const paths = location.pathname.split('/');
        setCurrentTab(paths[6]);
        setIsFundView(!!params.fundId);
    }, [location, params]);

    return (
        <section >
            {isFundView && (<>
                <Link className="btn-back mt-m ml-s" to={`/cases/${params.slug}/claimant-details/${params.institutionId}/view/funds`}>Return</Link>
            </>)}
            {!isFundView && (
                <ul className="nav-menu">
                    <li> <Link className={clsx({ 'active': currentTab === 'index' })} to={`/cases/${params.slug}/claimant-details/${params.institutionId}/view/index`}>Claimant's details</Link> </li>
                    <li> <Link className={clsx({ 'active': currentTab === 'funds' })} to={`/cases/${params.slug}/claimant-details/${params.institutionId}/view/funds`}>Funds</Link> </li>
                    <li> <Link className={clsx({ 'active': currentTab === 'files' })} to={`/cases/${params.slug}/claimant-details/${params.institutionId}/view/files`}>Files</Link> </li>
                </ul>
            )}
            <Outlet context={outletContext} />
        </section>
    );
}